/**
 * Configuration helpers for CDDRecordDetail component
 */

export interface CDDRecordLocal {
	id: string;
	reference: string;
	clientName: string;
	customer: string;
	email: string;
	abn: string;
	type: string;
	status: 'pending' | 'completed' | 'failed' | 'under-review';
	createdDate: string;
	completedDate?: string;
	riskLevel: 'low' | 'medium' | 'high';
	documents: string[];
	reason?: string;
}

export const getRiskColor = (risk: string): string => {
	switch (risk) {
		case 'low':
			return '#28a745';
		case 'medium':
			return '#ffc107';
		case 'high':
			return '#dc3545';
		default:
			return '#999';
	}
};

export const getRiskLabel = (risk: string): string => {
	switch (risk) {
		case 'low':
			return '🟢 Low Risk';
		case 'medium':
			return '🟡 Medium Risk';
		case 'high':
			return '🔴 High Risk';
		default:
			return 'Unknown';
	}
};

export const getStatusColor = (status: string): string => {
	switch (status) {
		case 'completed':
			return '#28a745';
		case 'failed':
			return '#dc3545';
		case 'pending':
			return '#ffc107';
		case 'under-review':
			return '#17a2b8';
		default:
			return '#999';
	}
};

export const getStatusLabel = (status: string): string => {
	switch (status) {
		case 'active':
			return '✅ Active';
		case 'completed':
			return '✅ Completed';
		case 'failed':
			return '❌ Failed';
		case 'pending':
			return '⏳ Pending';
		case 'pending-review':
			return '🔍 Pending Review';
		case 'in-progress':
			return '🔄 In Progress';
		case 'under-review':
			return '🔍 Under Review';
		default:
			return status;
	}
};
